import React from 'react';

import Header from '../bumpers/header';
import Footer from '../bumpers/footer';
import PageNav from '../page-nav';
import Intro from '../intro';

import * as css from './index.module.css';

export default function Layout({ children, navs, debug }) {

    

    return (
        <div className={`${css.layout} ${debug.border ? css.layoutDebug : ''}`}>

            <Header nav={navs.mainNav} />
            <Intro />
            <PageNav />

            <main>{children}</main>

            <Footer nav={navs.footerNav} />

        </div>
    );
}
